import { call, put, takeEvery } from "redux-saga/effects";
import PortalService from "services/PortalService";
import { AUTH_TOKEN } from "store/auth/login/actionTypes";
import {
  DOWNLOAD_FILE,
  GET_CAPCHA,
  GET_SEARCH_RESULT,
  SEARCH_CODE_PORTAL,
} from "store/portal/actionTypes";
import {
  downloadFileFail,
  downloadFileSuccess,
  getCapchaFail,
  getCapchaSuccess,
  getSearchResultFail,
  getSearchResultSuccess,
  searchCodePortalFail,
  searchCodePortalSuccess,
} from "./actions";
function* getCapcha() {
  try {
    const response = yield call(PortalService.getCapcha);
    yield put(getCapchaSuccess(response));
  } catch (error) {
    yield put(getCapchaFail(error));
  }
}
function* searchCodePortal({ payload }) {
  try {
    const response = yield call(PortalService.searchCodePortal, payload);
    if (response.status === false) {
      yield put(searchCodePortalFail(response));
    } else {
      localStorage.setItem(AUTH_TOKEN, response?.token);
      yield put(searchCodePortalSuccess(response));
    }
  } catch (error) {
    yield put(searchCodePortalFail(error));
  }
}
function* getSearchResult({ payload }) {
  try {
    const response = yield call(PortalService.getSearchResult, payload);
    yield put(getSearchResultSuccess(response));
  } catch (error) {
    yield put(getSearchResultFail(error));
  }
}
function* downloadFile({ payload }) {
  try {
    const response = yield call(PortalService.downloadFile, payload);
    yield put(downloadFileSuccess(response));
  } catch (error) {
    yield put(downloadFileFail(error));
  }
}
function* portalSaga() {
  yield takeEvery(SEARCH_CODE_PORTAL, searchCodePortal);
  yield takeEvery(GET_SEARCH_RESULT, getSearchResult);
  yield takeEvery(GET_CAPCHA, getCapcha);
  yield takeEvery(DOWNLOAD_FILE, downloadFile);
}

export default portalSaga;
